<template>
  <v-container>
    <MessagePopup :text="errorMessage" color="error"/>
    <v-data-table
      :headers="headers"
      :items="items"
      :loading="loading"
      show-expand
      item-key="SalesorderId"
    >
      <template v-slot:top>
        <v-container>
          <v-row>
            <v-col
              cols="12" sm="5" md="2"
            >
              <v-menu
                v-model="menuStartDate"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="filters.startdate"
                    label="Start date"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="filters.startdate"
                  @input="menuDateStart = false"
                  no-title
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col
              cols="12" sm="5" md="2"
            >
              <v-menu
                v-model="menuEndDate"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="filters.enddate"
                    label="End date"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="filters.enddate"
                  @input="menuEndDate = false"
                  no-title
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col
              cols="12" sm="6" md="3"
            >
              <v-switch
                v-model="filters.openonly"
                label="Open orders only"
              ></v-switch>
            </v-col>
            <v-col
              cols="12" sm="6" md="3"
            >
              <v-switch
                v-model="filters.companyorders"
                label="Company orders"
              ></v-switch>
            </v-col>
            <v-col
              cols="12" sm="2" md="2"
            >
              <v-btn color="primary" @click="getData">Search</v-btn>
            </v-col>
          </v-row>
        </v-container>
      </template>
      <template v-slot:item.orderDetails="{ item }">
        <span v-if="item.orderDetails.LineItems">
          {{ item.orderDetails.LineItems.length }}
        </span>
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length" v-if="item.orderDetails.error">{{ item.orderDetails.error }}</td>
        <td :colspan="headers.length" v-else-if="item.orderDetails.LineItems && item.orderDetails.LineItems.length === 0">No order found!</td>
        <td :colspan="headers.length" v-else>
          <v-container>
            <v-row>
              <v-col cols="12" md="6">
                <h3>Header</h3>
                <p>
                  Customer Id: {{ item.orderDetails.CustomerId }}<br/>
                  Email: {{ item.orderDetails.Email }}<br/>
                  Ship To: {{ item.orderDetails.ShippingAddress.FirstName }} {{ item.orderDetails.ShippingAddress.LastName }}, {{ item.orderDetails.ShippingAddress.Company }} - {{ item.orderDetails.ShippingAddress.City }}<br/>
                  Shipment Type: {{ item.orderDetails.ShipmentType }}<br/>
                  Shipping Method: {{ item.orderDetails.ShippingMethod }}<br/>
                  Payment Method: {{ item.orderDetails.PaymentMethod }}<br/>
                  Billing Account: {{ item.orderDetails.BillingAccount }} ({{ item.orderDetails.BillingAddress.Company }} - {{ item.orderDetails.BillingAddress.City }})<br/>
                </p>
              </v-col>
              <v-col cols="12" md="6">
                <h3>Shipments</h3>
                <v-simple-table class="mb-8">
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th>Date</th>
                        <th>Invoice Id</th>
                        <th>Tracking</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(ship, key) in item.orderDetails.ShippingDetails.filter(ship => !ship.CanceledOrVoided)" :key="key">
                        <td>{{ ship.DateTransaction.substring(0, 10) }}</td>
                        <td>{{ ship.InvoiceId }}</td>
                        <td><v-btn text small :href="ship.TrackingUrl" target="_blank">{{ ship.CarrierPackageId }}</v-btn></td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
              <v-col cols="12">
                <h3>Line items</h3>
                <v-simple-table class="mb-8">
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th>Customer Ref</th>
                        <th>DGK PN</th>
                        <th>Manufacturer</th>
                        <th>Manufacturer PN</th>
                        <th>Qu (Bo)</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(lineItem, key) in item.orderDetails.LineItems" :key="key">
                        <td>{{ lineItem.CustomerReference }}</td>
                        <td>{{ lineItem.DigiKeyPartNumber }}</td>
                        <td>{{ lineItem.Manufacturer }}</td>
                        <td>{{ lineItem.ManufacturerPartNumber }}</td>
                        <td>{{ lineItem.Quantity }}<span v-if="lineItem.QuantityShipped < lineItem.Quantity"> ({{ lineItem.Quantity - lineItem.QuantityShipped }})</span></td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
            </v-row>
          </v-container>
        </td>
      </template>
      <template v-slot:item.DateEntered="{ item }">
        {{ item.DateEntered.substring(0, 10) }}
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import MessagePopup from '@/components/MessagePopup.vue'

export default {
  data: () => ({
    headers: [
      { text: 'Supplier', value: 'supplier.name' },
      { text: 'Sales Order ID', value: 'SalesorderId' },
      { text: 'Date Entered', value: 'DateEntered' },
      { text: 'Purchase Order', value: 'PurchaseOrder' },
      { text: 'items', value: 'orderDetails' },
      { text: 'Details', value: 'data-table-expand' }
    ],
    items: [],
    loading: true,
    filters: {
      startdate: null,
      enddate: null,
      openonly: true,
      companyorders: false
    },
    menuStartDate: false,
    menuEndDate: false,
    errorMessage: ''
  }),
  created () {
    const today = new Date()
    this.filters.startdate = new Date(Date.UTC(today.getFullYear(), today.getMonth() - 1, today.getDate())).toISOString().substring(0, 10)
    this.filters.enddate = new Date(Date.UTC(today.getFullYear(), today.getMonth(), today.getDate())).toISOString().substring(0, 10)
    this.getData()
  },
  computed: {
    ...mapState(['suppliers']),
    ...mapGetters(['isSupplierCapableOf'])
  },
  components: {
    MessagePopup
  },
  methods: {
    getData () {
      this.items = []
      this.loading = true
      const promisesArray = []
      this.suppliers
        .filter(supplier => supplier.enabled && this.isSupplierCapableOf({ connectorName: supplier.connector, capability: 'orderHistory' }))
        .forEach(supplier => {
          promisesArray.push(
            this.$http(
              this.$directory + `/suppliers/${supplier.id}/orderhistory`,
              {
                params: this.filters
              }
            )
              .then(response => {
                response.data['hydra:member'].forEach(order => {
                  this.items.push({ ...order, ...{ supplier } })
                })
              })
              .catch(error => {
                if (!error.response) {
                  this.errorMessage = `Supplier ${supplier.name}: ${error.message}`
                } else {
                  this.errorMessage = `Supplier ${supplier.name}: ${error.response.data['hydra:description'].replace(/\n/g, '<br/>')}`
                }
              })
          )
        })
      Promise.all(promisesArray)
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
